/**
 * misradia — filter bar UI helpers for collection and search pages.
 *
 * The filter bar is teleported out of the section (see snippets/facets.liquid) and is therefore
 * NOT re-rendered by facets.js when a filter changes: only #active-filter-tag and the product grid
 * are. So the badge on the filter button is derived from the active-filter chips and kept in sync
 * with a MutationObserver on that container.
 */
(function () {
  if (window.__misradiaFilterUI) return;
  window.__misradiaFilterUI = true;

  var CHIPS = '#active-filter-tag';
  var CHIP = '.active-filter-control';
  var BADGE = '[data-active-filter-count]';

  function syncBadges() {
    var container = document.querySelector(CHIPS);
    var count = container ? container.querySelectorAll(CHIP).length : 0;

    document.querySelectorAll(BADGE).forEach(function (badge) {
      badge.textContent = count;
      badge.hidden = count === 0;
    });
  }

  function start() {
    syncBadges();

    var container = document.querySelector(CHIPS);
    if (!container) return;

    new MutationObserver(syncBadges).observe(container, {childList: true, subtree: true});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
